import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { Audit } from 'src/app/core-module/models/Audits/audit';
import { AuditCollectionResult } from 'src/app/core-module/models/Audits/audit-collection-result';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { Campaign } from 'src/app/core-module/models/Campaigns/campaign';
import { CampaignDetail } from 'src/app/core-module/models/Campaigns/campaign-detail';
import { CampaignReturn } from 'src/app/core-module/models/Campaigns/campaign-return';
import { DDL } from 'src/app/core-module/models/ddl';
import { AuditLocation } from 'src/app/core-module/models/Locations/audit-location';
import { AuditLocationResult } from 'src/app/core-module/models/Locations/audit-location-result';
import { TasksResult } from 'src/app/core-module/models/Tasks/TasksResult';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditRequestsService } from 'src/app/core-module/services/audit-requests.service';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { ReferenceService } from 'src/app/core-module/services/reference.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
  selector: 'app-new-campaign',
  templateUrl: './new-campaign.component.html',
  styleUrl: './new-campaign.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NewCampaignComponent {
  public unsavedChanges: boolean = false;
  public showActionSectionBar: boolean = false;
  public backURL: string = "";
  public backPageNo: number = 0;

  //page variables
  public campaignName: string = "";
  public audits: FlattenedQuestionHolder[] = [];
  public selectedAudit: FlattenedQuestionHolder = new FlattenedQuestionHolder();
  public auditName: string = "";
  public customName: string = "";
  public selectedCalendarSendDate: Date = new Date();
  public selectedCalendarDate: Date = new Date();
  public formattedSendDate: string = "";
  public formattedDate: string = "";
  public recipients: CampaignDetail[] = [];
  public currentRName: string = "";
  public currentREmail: string = "";
  public currentRRef: string = "";
  public anonymousAudit: boolean = false;
  public anonymousFormatted: string = "";
  public selectedGDPR: boolean = false;
  public validatedReturn: CampaignReturn = new CampaignReturn();
  public requestGUID: string = "";
  public request: Campaign = new Campaign();
  public locations: AuditLocation[] = [];
  public selectedLocation: AuditLocation = new AuditLocation();
  public createLink: boolean = false;
  public skipEmails: boolean = false;

  //page display options
  public showIntro: boolean = true;
  public showAuditNaming: boolean = false;
  public showEmails: boolean = false;
  public showSummary: boolean = false;
  public showCampaignDetails: boolean = false;
  public showAuditDetails: boolean = false;
  public showSummaryEmailList: boolean = false;
  public displayFullConsentDetails: boolean = false;
  public loadingValidation: boolean = false;
  public signatureWarning: boolean = false;
  public repeatWarning:boolean = false;
  public showLocations: boolean = false;
  public showCampaignTypeSelect: boolean = false;

  //Progress bar settings
  public pbGeneral: boolean = false;
  public pbAudit: boolean = false;
  public pbCampaign: boolean = false;
  public pbEmails: boolean = false;
  public pbLocation: boolean = false;
  public pbType: boolean = false;

  //Validation switches
  public errorEmail: boolean = false;
  public errorPastSendDate: boolean = false;
  public errorExpiryBeforeSend: boolean = false;
  public errorNoLocationSelected: boolean = false;





  constructor(private util: UtilService, private toastr: ToastrService, private requestService: AuditRequestsService, private router: Router, private refService: ReferenceService) {
    this.createAuditList();
    this.createLocationList();
    this.selectedCalendarDate.setMonth(this.selectedCalendarDate.getMonth() + 1);
    this.requestGUID = crypto.randomUUID();
  }

  createAuditList() {
    this.audits = [];
    var pleaseSelect = new FlattenedQuestionHolder({ AuditName: "Please select...", AuditID: -1 });

    this.requestService.getAuditList().pipe(tap(res => {
      this.audits = [pleaseSelect, ...res.Audits]

    })).subscribe();
    this.selectedAudit = pleaseSelect;
  }
  createLocationList() {
    this.locations = [];
    var pleaseSelect = new AuditLocation({ LocationName: "Please select...", LocationID: -1 })
    this.requestService.getCampaignLocations(true).pipe(tap(res => {
      if (!res.IsError) {
        res.Locations.forEach(e => {
          this.locations = [pleaseSelect, ...res.Locations]
        })
      }

    })).subscribe();
    this.selectedLocation = pleaseSelect;
  }

  showSidePanel() {
    if (this.pbAudit || this.pbCampaign || this.pbEmails) {
      this.pbGeneral = true;
    } else {
      this.pbGeneral = false;
    }
  }


  returnToInfoPage() {
    this.resetProgressBar();
    this.resetAllSections();
    this.showIntro = true;
    this.backURL = "";
  }
  resetProgressBar() {
    this.pbAudit = false;
    this.pbCampaign = false;
    this.pbEmails = false;
    this.pbLocation = false;
    this.pbType = false;
  }
  confirmCampaignDetails() {
    this.pbCampaign = true;
    this.formattedDate = this.util.humanDate(this.selectedCalendarDate);
    this.formattedSendDate = this.util.humanDate(this.selectedCalendarSendDate);
    this.updateAnonymousText();
    this.switchToAuditDetails();
    this.showSidePanel();
    this.backPageNo = 2
  }

  returnToCampaignDetails() {
    this.pbCampaign = false;
    this.switchToCampaignDetails();
    this.showSidePanel();
    this.backPageNo = 1;

  }
  returnToAuditDetails() {
    this.pbAudit = false;
    this.switchToAuditDetails();

    this.showSidePanel();
    this.backPageNo = 2
  }
  returnToLocationDetails() {
    this.pbLocation = false;
    this.switchToLocations();
    this.showSidePanel();
    this.backPageNo = 3
  }
  returnToTypeSelect() {
    this.pbType = false;
    this.showSidePanel();
    this.switchToTypeSelect();
    this.backPageNo = 4;
  }
  returnEmailOrType() {
    if (this.skipEmails) {
      this.returnToTypeSelect();
    } else {
      this.returnToEmail();
    }
  }
  returnToEmail() {
    this.pbEmails = false;
    this.showSidePanel();
    this.switchToEmailList();
    this.backPageNo = 5;
  }
  updateAuditSelection() {
    this.auditName = this.selectedAudit.AuditName;
    this.customName = this.auditName;
    this.signatureWarning = this.selectedAudit.AuditInfo.ContainsSignature;
    this.repeatWarning = this.selectedAudit.AuditInfo.ContainsRepeat;
  }
  confirmAuditNaming() {
    if (this.customName.length > 0) {
      this.auditName = this.customName;
    }
    this.pbAudit = true;
    this.switchToLocations();
    this.showSidePanel();
    this.backPageNo = 3
  }

  confirmLocation() {
    this.switchToTypeSelect();
    this.pbLocation = true;
    this.showSidePanel();
    this.backPageNo = 4
  }
  confirmCampaignType(createLink: boolean, skipEmail: boolean) {
    this.createLink = createLink;
    this.skipEmails = skipEmail
    this.pbType = true;
    this.showSidePanel();
    if (skipEmail) {
      this.switchToSummary();
      this.createValidationRequest();
    } else {
      this.switchToEmailList();
      this.showSidePanel();

    }
    this.backPageNo = 5

  }


  addReceipient() {
    if (this.validReceipient()) {
      this.recipients.push(new CampaignDetail({ "Name": this.currentRName, "Reference": this.currentRRef, "Email": this.currentREmail, "GUID": crypto.randomUUID() }));
      this.clearReceipientFields();
    } else {
      this.toastr.addToastr(new Toastr({ Type: 3, Message: "Please review receipients details" }));
      //Highlight field issues      
    }

  }
  removeReceipient(GUID: string) {
    var indexGUID = this.recipients.findIndex(x => x.GUID == GUID);
    if (indexGUID != -1) {
      this.recipients.splice(indexGUID, 1);
    }
  }
  clearReceipientFields() {
    this.currentRName = "";
    this.currentRRef = "";
    this.currentREmail = "";
  }

  validReceipient(): boolean {
    var validReceipient: boolean = true;
    if (!this.util.validEmail(this.currentREmail)) {
      validReceipient = false;
      this.errorEmail = true;
    }
    return validReceipient;
  }
  resetEmailValidation() {
    this.errorEmail = false;
  }




  validateEmails() {
    this.loadingValidation = true;
    this.createValidationRequest();
    this.sendValidationRequest();
    this.backPageNo = 4;
  }




  switchToAuditNaming() {
    this.resetAllSections();
    this.showAuditNaming = true;
  }
  switchToTypeSelect() {
    this.resetAllSections();
    this.showCampaignTypeSelect = true;
  }
  switchToEmailList() {
    this.resetAllSections();
    this.showEmails = true;
  }

  switchToSummary() {
    this.resetAllSections();
    this.pbGeneral = false;
    this.showSummary = true;
  }

  switchToCampaignDetails() {
    this.resetAllSections();
    this.showCampaignDetails = true;
    this.backPageNo = 1;
    this.backURL = "return";
  }
  switchToAuditDetails() {
    this.resetAllSections();
    this.showAuditDetails = true;
  }
  switchToLocations() {
    this.resetAllSections();
    this.showLocations = true;
  }

  resetAllSections() {
    this.showIntro = false;
    this.showAuditDetails = false;
    this.showAuditNaming = false;
    this.showCampaignTypeSelect = false;
    this.showEmails = false;
    this.showCampaignDetails = false;
    this.showSummary = false;
    this.showLocations = false;
  }





  updateCurrentDate() {
    var ExpiryDate: Date = new Date(this.selectedCalendarDate.getFullYear(), this.selectedCalendarDate.getMonth(), this.selectedCalendarDate.getDate());
    var SendDate: Date = new Date(this.selectedCalendarSendDate.getFullYear(), this.selectedCalendarSendDate.getMonth(), this.selectedCalendarSendDate.getDate());
    if (SendDate > ExpiryDate) {
      this.errorExpiryBeforeSend = true;
    } else {
      this.errorExpiryBeforeSend = false;
    }
  }
  updateCurrentSendDate() {
    var SendDate: Date = new Date(this.selectedCalendarSendDate.getFullYear(), this.selectedCalendarSendDate.getMonth(), this.selectedCalendarSendDate.getDate());
    var CurrentDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    if (SendDate < CurrentDate) {
      this.errorPastSendDate = true;
    } else {
      this.errorPastSendDate = false;
    }
  }
  updateAnonymousText() {
    if (this.anonymousAudit) {
      this.anonymousFormatted = "Anonymous Responses";
    } else {
      this.anonymousFormatted = "Visible Responses"
    }
  }
  switchFullConsentView() {
    this.displayFullConsentDetails = !this.displayFullConsentDetails;
  }

  createValidationRequest() {
    this.request = new Campaign();
    this.request.SelectedAuditID = this.selectedAudit.AuditID;
    this.request.Recipients = this.recipients;
    this.request.Anonymous = this.anonymousAudit;
    this.request.ExpiryDate = this.selectedCalendarDate;
    this.request.SendDate = this.selectedCalendarSendDate;
    this.request.RequestName = this.campaignName;
    this.request.RequestGUID = this.requestGUID;
    this.request.Location.ID = this.selectedLocation.LocationID;
    this.request.CreateLink = this.createLink;
    if (this.skipEmails) {
      this.request.Recipients = [];
    }
    if (this.customName.length > 0) {
      this.request.PublicAuditName = this.customName;
    } else {
      this.request.PublicAuditName = this.auditName;
    }
  }
  sendValidationRequest() {
    this.requestService.validateAuditRequest(this.request).pipe(tap(res => {
      if (res.IsError) {
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to validate, please try again." }));
        console.error(res.ErrorCode);
        this.loadingValidation = false;
      } else {
        this.validatedReturn = new CampaignReturn(res);
        this.toastr.addToastr(new Toastr({ Type: 2, Message: "Validation Complete." }));
        this.loadingValidation = false;
        this.switchToSummary();
      }
    })).subscribe();
  }
  sendFullRequest() {
    this.requestService.saveAuditCampaign(this.request).pipe(tap(res => {
      if (res.IsError) {
        if (res.ErrorCode = "SCR001") {

          this.toastr.addToastr(new Toastr({ Type: 1, Message: "Feedback campaign already saved." }));
          this.router.navigateByUrl('settings/campaigns/campaignlist');
        } else {
          this.toastr.addToastr(new Toastr({ Type: 3, Message: "Unable to save feedback campaign, please try again." }));
          console.error(res.ErrorCode);
          this.loadingValidation = false;
        }

      } else {
        this.toastr.addToastr(new Toastr({ Type: 2, Message: "Save successful." }));
        this.router.navigateByUrl('settings/campaigns/campaignlist');
      }
    })).subscribe();
  }




  validEmailCount() {
    return this.validatedReturn.Request.Recipients.filter(x => x.FailedCheck == false).length;
  }
  invalidEmailCount() {
    return this.validatedReturn.Request.Recipients.filter(x => x.FailedCheck == true).length;
  }
  displayFullValidatedEmailList() {
    this.showSummaryEmailList = !this.showSummaryEmailList;
  }
  localBack() {
    console.log(this.backPageNo);
    switch (this.backPageNo) {
      case 0:
        break;
      case 1:
        this.returnToInfoPage();
        break;
      case 2:
        this.returnToCampaignDetails();
        break;
      case 3:
        this.returnToAuditDetails();
        break;
      case 4:
        this.returnToLocationDetails();
        break;
      case 5:
        this.returnToTypeSelect();
        break;
      case 6:
        this.returnToEmail();
        break;

    }
  }
}
